module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "toc-title"
  }, [_c('span', [_c('i', [_vm._v("Contents")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry"
  }, [_c('span', [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter01"
    }
  }, [_vm._v("How to Read and Understand History")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry1"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter02",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Value of Free Thought")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry1"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Mentalism vs. Materialism")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry2"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter03#chap_01",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Meaning of Matter")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry2"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter03#chap_02",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Nature of “Mass”")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry2"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter03#chap_03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Ups and Downs of the Atomic Theory")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry2"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter03#chap_04",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Quantum Theory")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry2"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter03#chap_05",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Behavior of Matter in Bulk")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry2"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter03#chap_06",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Physics Is Still Deterministic")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry2"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter03#chap_07",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Psychology Also Has Changed")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry2"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter03#chap_08",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Life As It Appears in Biology")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry2"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter03#chap_09",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("What We Mean by Habit")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry2"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter03#chap_10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Habit Primarily Physical")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry2"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter03#chap_11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Physical Causes of Introspection")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry2"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter03#chap_12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Physical and Mental Overlap")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry2"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter03#chap_13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Definition of “Physical”")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry2"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter03#chap_14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Relations Between Mental and Physical Events")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry2"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter03#chap_15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Question of “Materialism”")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8ac427ca","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/contents.vue
// module id = 66
// module chunks = 0